export enum Route {
	HOME = '',
	LOGIN = 'login',
	DASHBOARD = 'dashboard',
	TRAINEES = 'trainees',
	ANALYTICS = 'analytics',
	FORBIDDEN = 'forbidden',
	UNAUTHORIZED = 'unauthorized'
}
